import { Box, Flex, Icon, Table, Tbody, Text, Th, Thead, Td as ChakraTd, Tr as ChakraTr, TableContainer, Tooltip } from '@chakra-ui/react'
import { Td, Tr } from '../../../../../../components/Table'
import { FaCheckCircle, FaPhone, FaWhatsapp } from 'react-icons/fa'
import { Telefone } from '../../../../../../components/Telefone'
import { CustomTooltip } from '../../../../../../components/CustomTooltip'

export function Item({ data, odd, infoLigacoes }) {
  const dados = { ...data, info_ligacoes: infoLigacoes }
  console.log('data: ', data)
  return (
    <Tr border="none">
      <Td borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'} py={0}>
        {data.abertura}
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        <Flex gap={2} alignItems="center" position="relative">
          <Flex flexDirection="column" alignItems="center" w="100%">
            <Text as="a" href={data.link_pdf} target="_blank" textDecor="underline" color="#378BBF">
              {data.proposta}
            </Text>
            <CustomTooltip
              label={
                <Box h="16px" px={2} bgColor="#378BBF" display="flex" alignItems="center" justifyContent="center" fontSize="12px" color="white">
                  {data?.info_itens?.length} itens
                </Box>
              }
              bg="#fff"
              color="black"
              fontSize="12px"
            >
              <TableContainer>
                <Table size="sm">
                  <Thead>
                    <ChakraTr>
                      <Th>Cod</Th>
                      <Th>Cor</Th>
                      <Th isNumeric>Qtd</Th>
                    </ChakraTr>
                  </Thead>
                  <Tbody>
                    {data?.info_itens?.map((item, index) => (
                      <ChakraTr bgColor="white!important" fontSize="12px" fontWeight="normal" key={index}>
                        <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                          {item.codigo_produto}
                        </ChakraTd>
                        <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                          {item.nome_cor}
                        </ChakraTd>
                        <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                          {item.quantidade_itens}
                        </ChakraTd>
                      </ChakraTr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </CustomTooltip>
          </Flex>
          {data?.pedido_especial === '1' && (
            <Icon as={FaCheckCircle} color="#378BBF" fontSize="20px" position="absolute" top="50%" transform="translateY(-50%)" right="-1" />
          )}
        </Flex>
      </Td>
      {/* 378BBF */}
      <Td py={0} h="36px" borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        <Flex justifyContent="center" alignItems="center" h="100%">
          {data?.desconto !== 'N' && <Icon as={FaCheckCircle} color="#76BF37" fontSize="20px" />}
        </Flex>
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.vendedor}
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        <Flex alignItems="center" justifyContent="space-between" gap={2} w="160px" mx="auto">
          <Tooltip label={data?.cliente}>
            <Text isTruncated textTransform={'capitalize'} textAlign="center">
              {data?.cliente}
            </Text>
          </Tooltip>
          {data?.cliente_especial === 'S' && <Icon as={FaCheckCircle} color="#FFA200" fontSize="20px" ml="auto" />}
        </Flex>
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.verba}
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.valorProposta}
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.prazo}
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.dataPropostaEncaminhada}
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        <Flex flexDirection="column" justifyContent="start" alignItems="center">
          {data.layoutEnviado}
          {data?.info_layout?.length > 0 && (
            <CustomTooltip
              label={
                <Box h="16px" px={2} bgColor="#378BBF" display="flex" alignItems="center" justifyContent="center" fontSize="12px" color="white">
                  {data?.info_layout?.length} layouts
                </Box>
              }
              bg="#fff"
              color="black"
              fontSize="12px"
            >
              <Table size="sm" bgColor="white!important">
                <Thead>
                  <ChakraTr>
                    <Th>Cod</Th>
                    <Th>Cor</Th>
                    <Th>Solicitado</Th>
                    <Th>Encaminhado ao Cliente</Th>
                  </ChakraTr>
                </Thead>
                <Tbody>
                  {data?.info_layout?.map((item, index) => (
                    <ChakraTr key={index}>
                      <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                        <Text as="a" target="_blank" textDecoration="underline" color="#378BBF" href={item.link_layout} cursor="pointer">
                          {item.codigo_produto}
                        </Text>
                      </ChakraTd>
                      <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                        {item.cor}
                      </ChakraTd>
                      <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                        <strong>{item.nome_usuario}</strong> {item.solicitacao}
                      </ChakraTd>
                      <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal" textAlign="center">
                        {item.encaminhado}
                      </ChakraTd>
                    </ChakraTr>
                  ))}
                </Tbody>
              </Table>
            </CustomTooltip>
          )}
        </Flex>
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.origem_contato}
      </Td>
      <Td py={1} textTransform="capitalize" borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'} position="relative">
        <Flex flexDir="column" alignItems="center">
          <Text w="100%" bgColor={data.lineColor} color="white">
            {data.funilVendas}
          </Text>
          <Text>{data.data_funil}</Text>
        </Flex>
      </Td>

      <Td py={0} bgColor={odd ? '#EDF2F7' : 'white'}>
        <Flex gap={2} alignItems="center" justifyContent="space-between">
          <Box as={data?.link_whats ? 'a' : 'div'} href={data.link_whats} target="_blank">
            <Icon
              as={FaWhatsapp}
              color={data?.link_whats ? '#25D366' : 'red.500'}
              fontSize="20px"
              _hover={{
                cursor: 'pointer',
                transform: 'scale(1.1)',
              }}
              transition="all 0.2s"
            />
          </Box>
          <Telefone {...dados} />
        </Flex>
      </Td>
    </Tr>
  )
}
